nextSessionIndex